import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { BaseService } from "../../services/base.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import {RequestData} from "../../interfaces/request-data";

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss']
})

export class ActivateComponent extends BaseService implements OnInit {
  public isDestroyed: Subject<boolean> = new Subject();
  public isTrueURL = false;
  public isSuccessEmail = false;
  public isActivateEmail = false;
  public messageInvalidURL = '';
  public errorMessageSuccess = '';
  public errorMessageActivate = '';

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) {
    super();
  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(data => {
        // бек кладе email у посилання без urlencode, а роутер читає «+» у query як пробіл -
        // для user+shop@… на бек ішов «user shop@…» і активація відповідала «Невірне посилання»
        // (пробілів в email не буває, тож повертаємо «+» назад). Стандартний кодек HttpParams
        // лишає «+» як є (а PHP знову читає його як пробіл) - кодуємо через encodeURIComponent.
        const params = new HttpParams({
          fromObject: typeof data['email'] === 'string'
            ? { ...data, email: data['email'].replace(/ /g, '+') }
            : data,
          encoder: {
            encodeKey: encodeURIComponent,
            encodeValue: encodeURIComponent,
            decodeKey: decodeURIComponent,
            decodeValue: decodeURIComponent,
          },
        });

        this.http.get(this.apiRoot + 'auth/activate', { params })
          .pipe(takeUntil(this.isDestroyed))
          .subscribe((params: RequestData) => {

              if (params.error === 'wrong data') {
                this.isTrueURL = true;
                this.messageInvalidURL = 'Невірне посилання.'
              } else if (params.data === 'success') {
                this.isSuccessEmail = true;
                this.errorMessageSuccess = 'Ви успішно підтвердили свій код активації'

                setTimeout(() => {
                   window.location.assign('/login')
                }, 5000)
              } else if (params.error === 'email activated') {
                this.isActivateEmail = true;
                this.errorMessageActivate = 'Ви успішно підтвердили ваш Емаil.\n ' +
                  'Чекайте активації облікового запису адміністратором.'
                setTimeout(() => {
                   window.location.assign('/login')
                }, 5000)
              } else {
                // server error з бека - без цього клієнт бачив порожню білу сторінку. Активація
                // могла вже записатись (лист/телеграм ідуть після неї), тож не пишемо «не вдалося»:
                // повторне відкриття посилання покаже справжній стан («Email уже підтверджено»)
                this.isActivateEmail = false;
                this.isTrueURL = true;
                this.messageInvalidURL = 'Не вдалося отримати відповідь сервера. Відкрийте посилання з листа ще раз.';
              }
          })
      })
  }
}
